module.exports = __webpack_public_path__ + "img/teacher06.7cf94e09.png";